import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

function PermissionRoute({ permission }) {
  const permissions = useSelector((state) => state.auth.permissions ?? []);
  const role = useSelector((state) => state.auth.userDetails?.role);

  if (!permission) {
    return <Outlet />;
  }
  if (role === 'SuperAdmin') {
    return <Outlet />;
  }
  if (Array.isArray(permissions) && permissions.includes(permission)) {
    return <Outlet />;
  }
  return <Navigate to="/" replace />;
}

export default PermissionRoute;
